import { ArrowRight } from 'lucide-react'
import { cn } from '@valiant/ui-shared'

function SwapArrow({ className, size = 'lg' }: { className?: string; size?: 'lg' | 'md' }) {
  const sizeClass = size === 'lg' ? 'w-8 h-8' : 'w-6 h-6'
  const iconClass = size === 'lg' ? 'w-5 h-5' : 'w-4 h-4'

  return (
    <div className={cn('rounded-full bg-gray-100 flex items-center justify-center', sizeClass)}>
      <ArrowRight className={cn('text-main', iconClass, className)} />
    </div>
  )
}

function SwapArrowMobile({ className }: { className?: string }) {
  return (
    <div
      className={cn(
        'rounded-xs bg-main/5 flex items-center justify-center h-full w-full border border-2 border-main/10',
      )}
    >
      <ArrowRight className={cn('text-main size-4', className)} />
    </div>
  )
}

export { SwapArrow, SwapArrowMobile }
